import AuthLoginFooter from "./authLoginFooter";
import AuthPassword from "./authPassword";
import { useTranslation } from "react-i18next";

export default function PasswordLayout({ children }) {
  const { t } = useTranslation();

  return (
    <>
      <div id="Auth">
        <div id="otpauthWrapper" style={{ overflow: "hidden" }}>
          <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6  hide-xs p-0 authenticate-ovel d-flex justify-content-center flex-column align-content-center align-items-center flex-wrap p-5">
              <AuthPassword />
            </div>
            <div className="col-xs-12 col-sm-12 col-md-5 col-lg-6 col-xl-6 p-0">
              <div className="authWrapper-container">{children}</div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="hide-xs"><div className="auth-noall-footer-section">
        <AuthLoginFooter />
      </div>
      <span className="footer-web-text">
        {/* www.tigiosbank.co.tz }
        [Bank Website]
      </span></div> */}
    </>
  );
}
